module.exports = __webpack_public_path__ + "9779d9a1/img/archive-icon.0a6a9de3.svg";